1
00:00:00,000 --> 00:00:01,564
[click target="#rc-tabs-1-tab-risks"]
[text content="Risks" style="fontSize:150px;lineHeight:120px" initial="scale(3) translate(0%, 10%)" final="scale(1) translate(0%, 0%)" duration="7s"]
Risks could be one of the most

2
00:00:01,564 --> 00:00:04,301
[click target="#rc-tabs-1-tab-summary"]
useful management tools a leader
has in its hands.

3
00:00:04,301 --> 00:00:05,931
[text remove=true]
[image url="https://app.gerositus.com/tutorials/risks-intro/Volatile.jpg" initial="scale(1.3)" final="scale(1)" duration="17s"]
Yet most leaders delegate the

4
00:00:05,931 --> 00:00:07,430
generation and management

5
00:00:07,430 --> 00:00:10,167
of extremely long excel
spreadsheets to experts.

6
00:00:10,167 --> 00:00:11,862
[image url="https://app.gerositus.com/tutorials/risks-intro/Risks.jpg" initial="scale(1)" final="scale(1.2)" duration="10s"]
They review them once or twice a

7
00:00:11,862 --> 00:00:13,686
year, because "they have to", and

8
00:00:13,686 --> 00:00:15,902
then put them in a drawer until
next time.

9
00:00:16,102 --> 00:00:17,580

10
00:00:19,180 --> 00:00:20,744
[image remove=true]
Well, let's see how risks are

11
00:00:20,744 --> 00:00:22,504
handled in Gerositus, and why we

12
00:00:22,504 --> 00:00:24,264
say that Gerositus allows you to

13
00:00:24,264 --> 00:00:26,805
make risk management a leadership
advantage.

14
00:00:28,205 --> 00:00:29,835
[image url="https://app.gerositus.com/tutorials/risks-intro/OrganizationRisks.jpg" initial="scale(1)" final="scale(1.3)" delay=3500 duration="12s"]
First, let's understand that

15
00:00:29,835 --> 00:00:31,203
whilst stakes represent

16
00:00:31,203 --> 00:00:32,637
principles, values or key

17
00:00:32,637 --> 00:00:34,527
fundamentals that could go beyond

18
00:00:34,527 --> 00:00:36,482
the organization itself, risks are

19
00:00:36,482 --> 00:00:39,089
much more specific to the
organization itself.

20
00:00:39,089 --> 00:00:40,914
They represent what could happen

21
00:00:40,914 --> 00:00:42,609
if nothing gets done to prevent

22
00:00:42,609 --> 00:00:45,085
[image remove=true]
the risk to realize or to mitigate
its impact.

23
00:00:45,285 --> 00:00:46,633
I like this say:
[text content="What you don't change, you choose" style="fontSize:120px;lineHeight:120px" initial="scale(3) translate(0%, 10%)" final="scale(1) translate(0%, 0%)" duration="7s" delay=2000]

24
00:00:48,433 --> 00:00:50,823
what you don't change, you choose.

25
00:00:52,423 --> 00:00:53,922
Somehow, if you don't try to

26
00:00:53,922 --> 00:00:55,421
change the normal course of

27
00:00:55,421 --> 00:00:58,679
action, then you choose the risks
that are associated to it.
[text remove=true]

28
00:00:58,679 --> 00:01:00,309
As you could identify several

29
00:01:00,309 --> 00:01:03,111
risks for one related stake, risks
can be numerous.

30
00:01:03,111 --> 00:01:05,653
It is therefore important to
categorize them.

31
00:01:05,653 --> 00:01:08,716
[image url="https://app.gerositus.com/tutorials/risks-intro/Existential.png" delay=4300]
The categorization used in
Gerositus is the following:

32
00:01:10,116 --> 00:01:12,071
Existential risks: they impact the

33
00:01:12,071 --> 00:01:14,809
"raison d'être", the mission of
the organization

34
00:01:14,809 --> 00:01:16,633
[image url="https://app.gerositus.com/tutorials/risks-intro/Strategic.png"]
Strategic risks: they impact the

35
00:01:16,633 --> 00:01:20,413
vision, the ambition, the business
model and/or the strategy itself

36
00:01:20,413 --> 00:01:22,238
[image url="https://app.gerositus.com/tutorials/risks-intro/Operational.png"]
Operational risks: they impact a

37
00:01:22,238 --> 00:01:25,236
part of the organization, a
business unit or a process.

38
00:01:26,836 --> 00:01:29,031
Let's take a concrete example.

39
00:01:29,231 --> 00:01:30,925
[image url="https://app.gerositus.com/tutorials/risks-intro/Run.png" initial="scale(1) translate(0%, 0%)" final="scale(1.2) translate(2%, 15%)" duration="10s"]
You may remember what happened

40
00:01:30,925 --> 00:01:33,011
during the Atlanta games
back in 1996.

41
00:01:33,011 --> 00:01:34,771
The Games were hit by violence in

42
00:01:34,771 --> 00:01:36,465
[image url="https://app.gerositus.com/tutorials/risks-intro/Atlanta-bombing.png" initial="scale(1.3) translate(0%, -2%)" final="scale(1.3) translate(0%, 5%)" duration="10s"]
the night of July 27, when a pipe

43
00:01:36,465 --> 00:01:38,290
bomb was detonated at Centennial

44
00:01:38,290 --> 00:01:41,940
Olympic Park where thousands of
people had gathered for a concert.

45
00:01:41,940 --> 00:01:44,286
The bomb killed two people and
injured 111.

46
00:01:45,860 --> 00:01:46,295
Ok let's pause a second.
[image remove=true]
[unmask target="main"]

47
00:01:47,688 --> 00:01:49,603
The primary goals of the Atlanta

48
00:01:49,603 --> 00:01:51,590
Olympic games, were to celebrate

49
00:01:51,590 --> 00:01:53,647
[createIndicator id="olympics-spirit" reference="Ol Spi" name="Develop olympics spirit" trend="80"]
the Olympic spirit, to contribute

50
00:01:53,647 --> 00:01:55,634
[createIndicator id="better-world" reference="Edu" name="Build a better world through education" trend="80"]
to building a peaceful and better

51
00:01:55,634 --> 00:01:57,620
world by educating youth through

52
00:01:57,620 --> 00:01:58,755
sport, to practice

53
00:01:58,755 --> 00:02:00,032
[createIndicator id="olympics-integrity" reference="No Discr" name="Olympics Integrity & prestige" trend="100"]
competition without

54
00:02:00,032 --> 00:02:02,161
discrimination, fostering mutual

55
00:02:02,161 --> 00:02:05,566
understanding, friendship,
solidarity, and fair play.

56
00:02:06,966 --> 00:02:08,740
From the point of view of Billy

57
00:02:08,740 --> 00:02:10,655
Payne, president of the Atlanta

58
00:02:10,655 --> 00:02:12,641
Committee for the Olympic Games,

59
00:02:12,641 --> 00:02:14,557
[createIndicator id="atlanta-reputation" reference="Atl Rep" name="Atlanta reputation" trend="100" weight="2"]
the goal was also to make Atlanta

60
00:02:14,557 --> 00:02:16,543
shine in the world, to develop the

61
00:02:16,543 --> 00:02:17,962
[createIndicator id="develop" reference="Dev" name="Develop Atlanta" trend="100"]
[createIndicator id="sponsorship" reference="ROI" name="Sponsorship & business ROI" trend="60" delay=2000]
city, to make the games a

62
00:02:17,962 --> 00:02:19,807
financial success, to offer an

63
00:02:19,807 --> 00:02:21,864
[createIndicator id="security" reference="Security" name="Secured environment" trend="90" weight="3" delay=1000]
environment that fosters olympic

64
00:02:21,864 --> 00:02:24,773
records, and many other very
positive outcomes.

65
00:02:26,173 --> 00:02:27,947
So when the bomb exploded, not

66
00:02:27,947 --> 00:02:29,720
[updateIndicator id="olympics-spirit" trend="0"]
[updateIndicator id="atlanta-reputation" trend="0" delay=300]
[updateIndicator id="sponsorship" trend="0" delay=600]
[updateIndicator id="security" trend="0" delay=900]
[updateIndicator id="develop" trend="0" delay=1200]
[updateIndicator id="better-world" trend="0" delay=1500]
[updateIndicator id="olympics-integrity" trend="0" delay=1800]
only the spirit of the Olympic

67
00:02:29,720 --> 00:02:31,494
movement and the future of the

68
00:02:31,494 --> 00:02:33,480
Olympic games were at stake, very

69
00:02:33,480 --> 00:02:35,254
[updateIndicator id="atlanta-reputation" trend="0"]
concretely the reputation of

70
00:02:35,254 --> 00:02:37,098
Atlanta, the credibility of US

71
00:02:37,098 --> 00:02:39,156
[updateIndicator id="sponsorship" trend="0" delay=2500]
national security, the financial

72
00:02:39,156 --> 00:02:41,213
return for the many businesses who

73
00:02:41,213 --> 00:02:44,477
invested in the games, and even
democracy were as well.

74
00:02:45,877 --> 00:02:47,792
At that moment, Billy Payne also

75
00:02:47,792 --> 00:02:50,204
had to consider a certain
number of risks

76
00:02:50,204 --> 00:02:53,822
[createRisk id="terrorist-attack" reference="Terror" name="Terrorist attack" impact="5" likelihood="3"]
Of course the risk of another
terrorist attack, but not only:

77
00:02:53,822 --> 00:02:55,738
[createRisk id="athletes-low-performance" reference="Ath Dis" name="Low performances/participation from athletes" impact="4" likelihood="2.5"]
The risk that athletes refuse to

78
00:02:55,738 --> 00:02:58,150
compete and thus de facto, the
games stop

79
00:02:58,150 --> 00:03:02,194
[createRisk id="logistical-failures" reference="Log Fail" name="Logistical failures" impact="4" likelihood="4.5"]
The risk that the staff disengages
, creating a logistics nightmare

80
00:03:02,194 --> 00:03:04,251
[createRisk id="pop-low-participation" reference="Pop Hom" name="Low participation from tourists and spectators" impact="4" likelihood="4"]
The risk that the population stays

81
00:03:04,251 --> 00:03:06,592
home, showing the world empty
stadiums

82
00:03:06,592 --> 00:03:08,579
[createRisk id="tourists-low-participation" reference="Trst Abs" name="Low participation from tourists and spectators" impact="4" likelihood="4"]
The risk that the tourists remain

83
00:03:08,579 --> 00:03:10,920
in their hotels, a disaster in
many ways

84
00:03:10,920 --> 00:03:12,481
[createRisk id="financial-losses" reference="Bankrpt" name="Financial losses due to event cancellation/hold" impact="4" likelihood="3.5" delay=2000]
The risk that Atlanta goes

85
00:03:12,481 --> 00:03:15,035
bankrupt as a combination of all
the above.

86
00:03:16,435 --> 00:03:18,208
If, at that point, you focus on

87
00:03:18,208 --> 00:03:20,124
those risks, then you will start

88
00:03:20,124 --> 00:03:22,891
playing not to lose, instead of
playing to win.

89
00:03:23,091 --> 00:03:24,300
The reason?

90
00:03:24,500 --> 00:03:28,473
Our brain doesn't work well with
negatives, it can't get creative.

91
00:03:28,473 --> 00:03:30,317
So, to come-up with meaningful

92
00:03:30,317 --> 00:03:33,652
actions, it is important to work
out the opportunities.

93
00:03:35,052 --> 00:03:37,961
[createRisk isOpportunity=true id="impossible-attacks" reference="Secur" name="Enhanced security measures as a showcase" impact="3" likelihood="3"]
What if we made any new attack
almost impossible?

94
00:03:37,961 --> 00:03:41,437
[createRisk isOpportunity=true id="athletes" reference="Best Perf" name="Best games ever in terms of athletes performances" impact="4.5" likelihood="2.5"]
What if we made athletes feel so
safe that they outperform?

95
00:03:41,437 --> 00:03:43,210
[createRisk isOpportunity=true id="staff" reference="Staff Motiv" name="Staff olympic pride and motivation" impact="3" likelihood="3"]
What if we could transform the

96
00:03:43,210 --> 00:03:46,261
attack in an even stronger
motivator for the staff?

97
00:03:46,261 --> 00:03:48,183
[createRisk isOpportunity=true id="population-participation" reference="Pop Part" name="Population increased participation" impact="3.5" likelihood="2.5"]
What if we could make the Atlanta

98
00:03:48,183 --> 00:03:50,318
population participate even more,

99
00:03:50,318 --> 00:03:52,524
as an act of pride against
terrorism?

100
00:03:52,524 --> 00:03:54,517
[createRisk isOpportunity=true id="tourists-image" reference="Image" name="Positive image of Atlanta" impact="1" likelihood="1"]
What if foreign spectators would

101
00:03:54,517 --> 00:03:57,577
go back home with a super positive
image of Atlanta?

102
00:03:57,577 --> 00:03:59,357
[createRisk isOpportunity=true id="business-profit" reference="Profit" name="Business profit" impact="5" likelihood="2.5"]
What if we made the games both a

103
00:03:59,357 --> 00:04:00,780
source of immediate and

104
00:04:00,780 --> 00:04:03,627
sustainable profit for
Atlanta's businesses?

105
00:04:03,627 --> 00:04:05,620
You now have the right mindset for

106
00:04:05,620 --> 00:04:07,542
the next question: what would it

107
00:04:07,542 --> 00:04:11,314
take to make the opportunities a
reality, what are the options?

108
00:04:12,714 --> 00:04:16,201
This is where we start seeing the
great power of Gerositus!

109
00:04:16,201 --> 00:04:18,123
[unmask target="header"]
By using the scenarios feature,

110
00:04:18,123 --> 00:04:22,036
you can run simulations according
to each option you came up with.
[hover target=".createScenario"]

111
00:04:22,036 --> 00:04:23,959
In other words you simulate what

112
00:04:23,959 --> 00:04:25,596
is the impact on the stakes,

113
00:04:25,596 --> 00:04:27,162
risks, opportunities and

114
00:04:27,162 --> 00:04:30,293
[blur target=".createScenario"]
[createScenario id="cancel-games" name="Stopping the games" delay=1000]
[click target=".createScenario"]
stakeholders, of, for example,
stopping the games.

115
00:04:30,293 --> 00:04:32,002
[click target=".ant-modal-close-x"]
Based on how each stake, each

116
00:04:32,002 --> 00:04:33,781
risk, each opportunity, each

117
00:04:33,781 --> 00:04:35,916
stakeholder would move, Gerositus

118
00:04:35,916 --> 00:04:37,838
will provide you with a clear and

119
00:04:37,838 --> 00:04:40,471
informed view of the most evident
solution.

120
00:04:40,471 --> 00:04:43,959
You will be able to see why, both
in the details and overall.

121
00:04:43,959 --> 00:04:46,663
In other words, Gerositus takes
biases away.

122
00:04:46,663 --> 00:04:48,514
In the concrete example we just

123
00:04:48,514 --> 00:04:50,151
[image url="https://app.gerositus.com/tutorials/risks-intro/ScenarioDetails.png" delay=1000]
took, you would see that the

124
00:04:50,151 --> 00:04:53,496
option of stopping the games would
have been a disaster.

125
00:04:53,496 --> 00:04:55,489
[image url="https://app.gerositus.com/tutorials/risks-intro/ScenarioDetails-Continue.png" delay=1000]
You also see why Billy Payne chose

126
00:04:55,489 --> 00:04:57,553
to continue the games, though with

127
00:04:57,553 --> 00:05:00,115
very significantly heightened
security.

128
00:05:00,115 --> 00:05:01,894
[image remove=true]
You now know enough to uncover

129
00:05:01,894 --> 00:05:03,602
risks so you can confront the
unmask target="sidemenu"

130
00:05:03,602 --> 00:05:07,588
reality, and to energize your team
by identifying opportunities.

